// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VZXR","left":"styles_left__26uUR"};